import { render } from "./doctor-list.vue?vue&type=template&id=767f8bac"
import script from "./doctor-list.vue?vue&type=script&lang=js"
export * from "./doctor-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__